import $ from 'jquery';
import { customProtocolCheck } from '../utils/custom-protocol-check.js';

var APPLET_SESSION = 'AppletSession';
var AX_CLSID = '12AEAFC3-BDC2-4A50-8831-98F1DF2307B7'; // 웹에 노출되는 AX의 CLSID
var AX_UPDATE_CLSID = '5D39E477-7E59-45e0-8BBD-3F0F1CCE9A5'; // AX의 업데이트에 사용되는 CLSID

// ver. 2018112001 / v1.1.0.38
// ver. 2019111201 / v1.1.0.41 : 로그인 풀림 수정
// ver. 2020052701 / v1.1.0.42 : 중복 로그인 수정
var AX_LATEST_VERSION = 2020052701;

var SUCCESS = 1;

/**
 * 게임을 실행하고 결과를 리턴한다.
 * mi6externalmethod 는 동기로 실행되며, 변수에 담아 참조로 실행할 수 없다.
 * 성공하면 1, 실패하면 0을 리턴
 */
export default function launch(param) {
  if (!param) {
    return false;
  }

  // eslint-disable-next-line no-underscore-dangle
  var app = window.__app || { trigger: function () {} /* noop */ };
  var AX = document.getElementById(APPLET_SESSION);

  app.trigger('app:gameLaunching');

  // 비 IE 브라우저일 경우 커스텀 URI 스킴으로 게임을 실행
  if (!$.browser.msie) {
    customProtocolCheck(param, function () {
      app.trigger('app:gameLaunched');
    });
    return true; // 성공 여부를 알 수 없으므로 실행으로 간주
  }

  if (!AX) {
    return false;
  }

  // 설치 체크
  if (AX.mi6externalmethod('isinstalled', AX_CLSID, 0, '1') !== SUCCESS) {
    AX.mi6externalmethod('install', AX_CLSID, 0, '피망 다운로드'); // 설치 시도
  }

  // 실행 시도
  if (AX.mi6externalmethod('run', AX_CLSID, 0, param) !== SUCCESS) {
    // 실행 실패, 설치 후 다시 시도
    AX.mi6externalmethod('install', AX_CLSID, 0, '피망 다운로드');
    AX.mi6externalmethod('run', AX_CLSID, 0, param);
  }

  return true;
}

/**
 * AX가 제대로 로딩되었는 지를 체크한다.
 * 설치는 되었으나, 보안 설정으로 실행이 차단된 상태라면, 이 함수는 무조건 false를 리턴한다.
 */
export function checkAXInstalled() {
  if (!$.browser.msie) {
    return false;
  }

  var AX = document.getElementById(APPLET_SESSION);
  var isInstalled;

  try {
    isInstalled = AX.isLoaded;
  } catch (err) {
    isInstalled = false;
  }

  return isInstalled;
}

/**
 * AX가 최신버전인지를 체크한다. IE에서 true 라면 AX를 업데이트하여야 한다.
 */
export function checkAXUpdateNeeded() {
  if (!$.browser.msie) {
    return false;
  }

  var AX = document.getElementById(APPLET_SESSION);
  var isUpdateNeeded;

  try {
    if (AX.sessionversion < AX_LATEST_VERSION) {
      console.log('AX ver.', AX.sessionversion, 'loaded. Update required.');
      isUpdateNeeded = true;
    } else {
      console.log('AX ver.', AX.sessionversion, 'loaded. No need to update.');
      isUpdateNeeded = false;
    }
  } catch (err) {
    console.log('Failed to check AX version.', err.name, err.message);
    isUpdateNeeded = false;
  }

  return isUpdateNeeded;
}

/**
 * AX를 통해 피망스타터가 설치되어 있는 지를 확인한다.
 * AX는 피망스타터의 clsid 가 윈도우 레지스트리에 있는 지 확인하며,
 * 피망스타터 파일이 유저의 하드에 존재하는 지도 검사한다.
 */
export function checkPmangStarterInstalled() {
  if (!$.browser.msie) {
    return false;
  }

  var AX = document.getElementById(APPLET_SESSION);
  return checkAXInstalled() && AX.mi6externalmethod('isinstalled', AX_CLSID, 0, '1') === SUCCESS;
}

/**
 * AX가 최신 버전이 아니라면 self-update를 실행한다.
 * 업데이트를 호출하는 메소드의 clsid가 게임 실행할 때와 다르다는 것을 주의
 */
export function tryUpdateAX() {
  if (!$.browser.msie) {
    return false;
  }

  if (!checkAXUpdateNeeded()) {
    return false;
  }

  var AX = document.getElementById(APPLET_SESSION);

  try {
    console.log('Trying to update AX. Latest ver.', AX_LATEST_VERSION);
    AX.externalmethod('install', AX_UPDATE_CLSID, 0, 0, '접속 프로그램 업그레이드');

    return true;
  } catch (err) {
    return false;
  }
}
